import { render, staticRenderFns } from "./ModalImageList.vue?vue&type=template&id=3b9897d0&scoped=true"
import script from "./ModalImageList.vue?vue&type=script&lang=js"
export * from "./ModalImageList.vue?vue&type=script&lang=js"
import style0 from "./ModalImageList.vue?vue&type=style&index=0&id=3b9897d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9897d0",
  null
  
)

export default component.exports